import React from 'react';
import ReactDOM from 'react-dom';

import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';

import App from './App';

require( 'react-js-vector-icons/fonts' );

initializeIcons();

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js